import { popupFeedTypes as actionTypes } from '@actions';
import { commonState, commonReducer } from '@dotone/react-ui-core/helpers';

const localizedState = {
  ...commonState.default({ localized: true, collection: true }),
};

export const popupFeedList = (state = localizedState, action) =>
  commonReducer(actionTypes.LIST, state, action);
